import tableConfig from '@/views/pages/tableConfig'

export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    // { key: 'id', sortable: true },
    { key: 'full_name', label: 'Full name' },
    { key: 'email', label: 'Email' },
    { key: 'mob_phone_no', label: 'Mobile phone' },
    { key: 'pport_no', label: 'Passport' },
    { key: 'tin', label: 'Tin' },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
    ...tableConfig('researchAdvisor', { endpoint: 'researchAdvisor/orgAdvisors' }),
  }
}
